import ReactDirective from "acl-ui/angular/reactDirective.umd";
import DownloadReportPanel from "@viz-ui/components/DownloadReportPanel/DownloadReportPanel";
import DownloadReportModal from "@viz-ui/components/DownloadReportModal/DownloadReportModal";

angular
  .module("acl.visualizer.downloadReportPanel", [])
  .directive("downloadReportPanel", ReactDirective.getFactory(DownloadReportPanel))
  .directive("downloadReportModal", ReactDirective.getFactory(DownloadReportModal));
